"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateProfile = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../classes/com/tmpls");
const StatePaged_1 = require("../../classes/states/abstracts/StatePaged");
const BreadCrumb_1 = require("../../classes/models/BreadCrumb");
const StateMain_1 = require("./StateMain");
const ClassesTags_1 = require("../../classes/ClassesTags");
const FavoriteController_1 = require("../controllers/FavoriteController");
const AppPM_1 = require("../AppPM");
const App_1 = require("../../classes/App");
class StateProfile extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageProfile, "Личный кабинет", true);
        const navDesk = this.page.ctrls.navDesk.ctrls;
        const navMob = this.page.ctrls.navMob.ctrls;
        this._handlerOnFavoriteChange = (count) => {
            if (!count) {
                navDesk.lFavouriteCount.text = navMob.lFavouriteCount.text = '';
            }
            else {
                navDesk.lFavouriteCount.text = navMob.lFavouriteCount.text = count + "";
            }
        };
        navDesk.aLogout.el.onclick =
            navMob.aLogout.el.onclick = (e) => __awaiter(this, void 0, void 0, function* () {
                gs.events.stop(e);
                yield this.app.auth.dropAuthAsync();
                gs.StateGS.Run(StateMain_1.StateMain);
            });
        this.page.ctrls.tabProductsFavourites.setIsTab();
        this.page.ctrls.btnBack.onclick = () => { this.page.ctrls.blockTabs.hide(); this.page.ctrls.navMob.show(); this.page.ctrls.btnBack.hide(); };
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const ctrl = this.page.ctrls;
            const navDesk = this.page.ctrls.navDesk;
            const navMob = this.page.ctrls.navMob;
            AppPM_1.AppPM.GUI.setBreadcrumbs([new BreadCrumb_1.BreadCrumb("Главная", "/"), new BreadCrumb_1.BreadCrumb(this.title, `/${StateProfile.StateName}`)]);
            const favoritesCount = this.app.getInst(FavoriteController_1.FavoriteController).getFavorites().length;
            if (!favoritesCount) {
                navDesk.ctrls.lFavouriteCount.text = navMob.ctrls.lFavouriteCount.text = '';
            }
            else {
                navDesk.ctrls.lFavouriteCount.text = navMob.ctrls.lFavouriteCount.text = favoritesCount + "";
            }
            if (!this.app.auth.user) {
                this.app.auth.authAsync((result) => {
                    if (!result) {
                        gs.StateGS.Run(StateMain_1.StateMain);
                        return;
                    }
                    gs.StateGS.Run(StateProfile);
                    return;
                });
                return _super.start.call(this);
            }
            navDesk.ctrls.lProfileName.text = navMob.ctrls.lProfileName.text = (_a = this.app.auth.user.name) !== null && _a !== void 0 ? _a : "Клиент #" + this.app.auth.user.id;
            navDesk.ctrls.lProfilePhone.text = navMob.ctrls.lProfilePhone.text = App_1.App.Inst.auth.phone;
            this._urlArgs["path0"] = StateProfile.StateName;
            if (args && args.path1) {
                this._urlArgs["path1"] = args.path1;
                ctrl.blockTabs.show();
                this.page.ctrls.btnBack.show();
                if (args.path1 == "config") {
                    ctrl.tabConfig.show();
                    navDesk.ctrls.aConfig.addClass(ClassesTags_1.ClassesTags.Active);
                    ctrl.tabConfig.loadAsync();
                    navMob.hide();
                    ctrl.lPageTitle.text = "Профиль";
                }
                else if (args.path1 == "support") {
                    ctrl.tabSupport.show();
                    navDesk.ctrls.aSupport.addClass(ClassesTags_1.ClassesTags.Active);
                    navMob.hide();
                    ctrl.lPageTitle.text = "Поддержка";
                }
                else if (args.path1 == "faq") {
                    ctrl.tabFAQ.show();
                    navDesk.ctrls.aFAQ.addClass(ClassesTags_1.ClassesTags.Active);
                    navMob.hide();
                    ctrl.lPageTitle.text = "Популярные вопросы";
                }
                else if (args.path1 == "notification") {
                    ctrl.tabNotifications.show();
                    navDesk.ctrls.aNotification.addClass(ClassesTags_1.ClassesTags.Active);
                    navMob.hide();
                }
                else if (args.path1 == "favourites") {
                    ctrl.tabProductsFavourites.show();
                    navDesk.ctrls.aFavourites.addClass(ClassesTags_1.ClassesTags.Active);
                    ctrl.tabProductsFavourites.loadAsync();
                    navMob.hide();
                    ctrl.lPageTitle.text = "Избранное";
                }
            }
            else {
                ctrl.tabOrders.show();
                navDesk.ctrls.aOrders.addClass(ClassesTags_1.ClassesTags.Active);
                ctrl.tabOrders.loadAsync();
                navMob.hide();
                ctrl.lPageTitle.text = "Заказы";
            }
            return _super.start.call(this);
        });
    }
    afterStart(args) {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this, args);
            this.app.getInst(FavoriteController_1.FavoriteController).onFavoriteChange.addHandler(this._handlerOnFavoriteChange);
        });
    }
    stop() {
        const _super = Object.create(null, {
            stop: { get: () => super.stop }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this.app.getInst(FavoriteController_1.FavoriteController).onFavoriteChange.removeHandler(this._handlerOnFavoriteChange);
            _super.stop.call(this);
        });
    }
}
exports.StateProfile = StateProfile;
StateProfile.StateName = "profile";
//# sourceMappingURL=StateProfile.js.map